import {HandPosition} from "../../HandPosition";
import {BlackjackHand} from "./BlackjackHand";

export class BlackjackInfoForClient {
    constructor(public dealerHand: BlackjackHand, public  blackjackHands: Array<BlackjackHand>,
                public  currentHandIndex: number, public  insurancePhaseFinished: boolean,
                public  currentInsuranceHandIndex: number, public  playerActionsFinished: boolean,
                public totalBet: number, public totalWin: number) {

    }

    public getFirstHandWithPosition(handPosition: HandPosition): BlackjackHand {
        for (let i = 0; i < this.blackjackHands.length; i++) {
            if (this.blackjackHands[i].getHandPosition() === handPosition) {
                return this.blackjackHands[i];
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/api/serverResponseClasses/BlackjackInfoForClient.ts